"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectAnswerBlock() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const principles = [{
    label: "PRINCIPLE 01 / PRECISION",
    title: "Industrial Accuracy",
    description: "Every label and tag we produce is engineered to meet rigorous industry standards, ensuring perfect legibility and compliance for your critical infrastructure.",
    terminus: "right"
  }, {
    label: "PRINCIPLE 02 / DURABILITY",
    title: "Built for Extremes",
    description: "We utilize high-grade materials designed to withstand harsh environments, from chemical exposure to extreme temperatures, ensuring your identification lasts a lifetime.",
    terminus: "left"
  }, {
    label: "PRINCIPLE 03 / SPEED",
    title: "Rapid Turnaround",
    description: "We understand the urgency of your projects. Our streamlined production process ensures your custom components are delivered on time, every time.",
    terminus: "right"
  }];
  return <section data-section-id="2135" id="direct-answer-block" className="bg-background text-foreground relative overflow-hidden border-t border-b" style={{
    borderColor: "var(--border)"
  }}>
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 md:px-12 lg:px-18 py-24 md:py-32">
        {}
        <div ref={headRef} className={`mx-auto max-w-[880px] text-center transition-all duration-700 ease-out ${headVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          {}
          <div className="flex items-center justify-center gap-4 mb-10">
            <span className="hidden sm:block h-px w-6" style={{
            backgroundColor: "var(--border)"
          }} aria-hidden="true" />
            <span className="font-mono uppercase font-medium" style={{
            color: "var(--muted-foreground)",
            letterSpacing: "0.18em",
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)"
          }}>
              § N° 02 — OUR STANDARDS
            </span>
          </div>

          {}
          <h2 className="font-default text-foreground" style={{
          fontSize: "clamp(2.25rem, 4.2vw, 4.25rem)",
          fontWeight: 600,
          lineHeight: 1.02,
          letterSpacing: "-0.02em"
        }}>
            We engineer{" "}
            <span className="font-default italic relative inline-block" style={{
            fontWeight: 600
          }}>
              precision
              <span className={`absolute left-0 right-0 -bottom-2 h-px transition-transform duration-[480ms] ease-out origin-left ${headVisible ? "scale-x-100" : "scale-x-0"}`} style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true">
                <span className="absolute right-0 -top-[2.5px] block h-[6px] w-[6px] rounded-lg" style={{
                backgroundColor: "var(--primary)"
              }} />
              </span>
            </span>
            , prioritize durability, and deliver excellence.
          </h2>
        </div>

        {}
        <div ref={gridRef} className="relative mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {}
          <div className="hidden md:flex md:col-span-5 relative items-start justify-center">
            <span aria-hidden="true" className="font-default select-none leading-none" style={{
            fontSize: "clamp(12rem, 22vw, 22rem)",
            fontWeight: 700,
            color: "var(--muted)",
            letterSpacing: "-0.05em"
          }}>
              02
            </span>
          </div>

          {}
          <div className="md:col-span-7 flex flex-col">
            {principles.map((principle, i) => <div data-index={i} key={i} className={`group relative py-8 md:py-10 ${i !== 0 ? "border-t" : ""} transition-all duration-700 ease-out`} style={{
            borderColor: "var(--border)",
            transitionDelay: `${i * 80}ms`,
            transform: gridVisible ? "translateY(0)" : "translateY(24px)",
            opacity: gridVisible ? 1 : 0
          }}>
                {}
                {i !== 0 && <span aria-hidden="true" className={`absolute -top-[3px] block h-[6px] w-[6px] rounded-lg transition-transform duration-300 group-hover:scale-[1.4] ${principle.terminus === "right" ? "right-0" : "left-0"}`} style={{
              backgroundColor: "var(--primary)"
            }} />}

                {}
                <div className="font-mono uppercase font-medium mb-4" style={{
              color: "var(--primary)",
              letterSpacing: "0.18em",
              fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)"
            }}>
                  {principle.label}
                </div>

                {}
                <h3 className="font-default text-foreground transition-transform duration-300 ease-out group-hover:-translate-y-0.5" style={{
              fontSize: "clamp(1.5rem, 2.2vw, 2.125rem)",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "-0.012em"
            }}>
                  {principle.title}
                </h3>

                {}
                <p className="font-default mt-4 max-w-[52ch]" style={{
              color: "var(--muted-foreground)",
              fontSize: "0.9375rem",
              lineHeight: 1.65
            }}>
                  {principle.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}